import React from 'react';
import { makeStyles } from '@mui/styles';
import { Avatar, Grid, Theme } from '@mui/material';
import {
  TaskAltOutlined,
  MailOutlined,
  EventOutlined,
} from '@mui/icons-material';

type IconCircleProps = {
  icons: ('task' | 'event' | 'coordination')[];
};

export const IconCircleCell = ({ icons }: IconCircleProps) => {
  const numIcons = icons.length;

  const classes = makeStyles((theme: Theme) => ({
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: 'transparent',
      color: 'inherit',
      overflow: 'visible',
    },
    icon: {
      fontSize: numIcons === 1 ? undefined : '15px',
    },
  }))();

  return (
    <Avatar className={classes.avatar}>
      <Grid container justifyContent="center" alignItems="center" spacing={0.1}>
        {icons.includes('task') && (
          <Grid item key={'t'}>
            <TaskAltOutlined fontSize="small" className={classes.icon} />
          </Grid>
        )}
        {icons.includes('event') && (
          <Grid item key={'e'}>
            <EventOutlined fontSize="small" className={classes.icon} />
          </Grid>
        )}
        {icons.includes('coordination') && (
          <Grid item key={'c'}>
            <MailOutlined
              fontSize="small"
              className={classes.icon}
              sx={{ pt: numIcons === 1 ? undefined : '2.3px' }}
            />
          </Grid>
        )}
      </Grid>
    </Avatar>
  );
};
